// The raw URL query string captured at app boot, before TanStack Router
// mounts and strips query params it doesn't recognise.
//
// Needed for the MCP OAuth flow: better-auth's authorize endpoint redirects an
// unauthenticated user to `/login?response_type=...&client_id=...&redirect_uri=...`.
// The router would otherwise drop those params before the login page can read
// them, breaking the hand-back to the authorize endpoint after sign-in. This
// module is imported first in main.tsx so the capture runs before any render.
export const BOOT_SEARCH =
  typeof window !== "undefined" ? window.location.search : "";
